import React from 'react' // eslint-disable-line no-unused-vars
import Footer from '../Footer'
import HeroImage from '../HeroImage'
import { connect } from 'react-redux'
import imgHeaderAbout from './assets/about-hero-desktop-1440x300.jpg'
import imgHeaderAboutMobile from './assets/about-hero-mobile-750x380.jpg'
import missionImage from './assets/our-mission-1076x660.jpeg'

const AboutUs = ({ pageContent }) => {
  const languageContent = pageContent.content.module.aboutUs

  return (
    <div className='page-container'>
      <div className='page-content'>
        <HeroImage
          title={languageContent.title}
          imageDesktop={imgHeaderAbout}
          imageMobile={imgHeaderAboutMobile}
        />
        <div className='container'>
          <div className='row' style={{ marginTop: '50px' }}>
            <div
              className='col-sm about-primary-section'
              style={{ marginTop: 'auto', marginBottom: 'auto'}}
            >
              <h3>{languageContent.ourMission}</h3>
              <p>{languageContent.ourMissionText}</p>
            </div>
            <div className='col-sm mt-3 mb-2'>
              <img
                src={missionImage}
                alt='A man and woman outside'
                className='about-image'
                style={{ width: '100%', maxWidth: '495px' }}
              />
            </div>
          </div>
          <div className='row about-background mt-5'>
            <div className='col-sm about-primary-section background-padding top'>
              <h3>{languageContent.whoWeAre}</h3>
              <p>{languageContent.whoWeAreText}</p>
            </div>
            <div className='col-sm about-primary-section background-padding bottom'>
              <h3>{languageContent.whatWeDo}</h3>
              <p>{languageContent.whatWeDoText}</p>
            </div>
          </div>
          <div className='row about-primary-section mt-5 mb-5'>
            <div className='col about-column-centered'>
              <div>
                <h3>{languageContent.ourPrinciples}</h3>
                <p>{languageContent.ourPrinciplesText}</p>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm about-secondary-section'>
              <h6>{languageContent.transformingLives}</h6>
              <p>
                {languageContent.transformingLivesText}
                <a
                  href='https://youtu.be/PajQ7F1s7so'
                  className='anchor-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  data-tag='track-exit'
                  data-analytics-text='Transforming Lives'
                >
                  {languageContent.watchTheVideo}
                </a>
              </p>
            </div>
            <div className='col-sm about-secondary-section'>
              <h6>{languageContent.actingWithIntegrity}</h6>
              <p>
                {languageContent.actingWithIntegrityText}
                <a
                  href='https://youtu.be/Qoi_Q8LWmxk'
                  className='anchor-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  data-tag='track-exit'
                  data-analytics-text='Acting with Integrity'
                >
                  {languageContent.watchTheVideo}
                </a>
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm about-secondary-section'>
              <h6>{languageContent.drivingInnovation}</h6>
              <p>
                {languageContent.drivingInnovationText}
                <a
                  href='https://youtu.be/Bv28_T97_e8'
                  className='anchor-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  data-tag='track-exit'
                  data-analytics-text='Driving Innovation'
                >
                  {languageContent.watchTheVideo}
                </a>
              </p>
            </div>
            <div className='col-sm about-secondary-section'>
              <h6>{languageContent.embracingDiversity}</h6>
              <p>
                {languageContent.embracingDiversityText}
                <a
                  href='https://youtu.be/LyiSW6l3-9I'
                  className='anchor-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  data-tag='track-exit'
                  data-analytics-text='Embracing Diversity & Inclusion'
                >
                  {languageContent.watchTheVideo}
                </a>
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm about-secondary-section'>
              <h6>{languageContent.servingTheCommunity}</h6>
              <p>
                {languageContent.servingTheCommunityText}
                <a
                  href='https://youtu.be/zXg0pejah9w'
                  className='anchor-link'
                  target='_blank'
                  rel='noopener noreferrer'
                  data-tag='track-exit'
                  data-analytics-text='Serving the Community'
                >
                  {languageContent.watchTheVideo}
                </a>
              </p>
            </div>
            <div className='col-sm about-secondary-section'>
              {/* Empty column */}
            </div>
          </div>
        </div>
      </div>
      <Footer submitInquiry={false} showHomeFooter={false} />
    </div>
  )
}

const mapStateToProps = state => ({
  pageContent: state.pageContent
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AboutUs)



// WEBPACK FOOTER //
// ./src/mi-app/aboutUs/AboutUs.js